<section class="hero-wrapper">
  <div
    *ngFor="let color of bgColors"
    [style.backgroundColor]="color"
    class="hero-box"
  ></div>
  <div class="hero-text-wrapper">
    <h1>Atrizult Consult</h1>
    <div class="bottom-text-wrapper">
      <div class="orange-line"></div>
      <p>{{ "contact-page.heroSubtext" | translate }}</p>
      <div class="orange-line"></div>
    </div>
  </div>
  <img
    src="assets/images/contact-us-image.png"
    alt="man-with-arms-folded"
    class="hero-image"
  />
</section>
